const reviews = document.getElementById('floating-reviews');
function closeReviews() {
    reviews.style.transition = 'transform 0.5s ease'; // Add transition for sliding effect
    reviews.style.transform = 'translateX(-150%)'; // Slide out to the right
    setTimeout(() => {
        reviews.style.display = 'none'; // Hide the element after sliding out
        localStorage.setItem('reviewsClosed', 'true'); // Save state in localStorage
    }, 500); // Match the timeout with the transition duration
}

if (localStorage.getItem('reviewsClosed') === 'true') {
    reviews.style.display = 'none'; 
} else {
    reviews.style.display = 'block';}